
import { Component, Vue } from "vue-property-decorator";
import { Route, RawLocation } from "vue-router";
import { API_ROUTES } from "@/utils/API";
import { API_THistory, convertHistoryForTable, THistory_Table } from "@/models/data_history";
import { SMUser } from "@/store";

Component.registerHooks(["beforeRouteEnter"]);

@Component({
  components: {
    Loader: () => import("@/components/Loader/Loader.vue"),
    DataHistory: () => import("@/components/DataHistory/DataHistory.vue"),
  },
})
export default class EmployerEmployeeCompanyDataHistory extends Vue {
  loading = false;

  get hideExpertItems() {
    return !SMUser.isExpert;
  }

  historyItems: THistory_Table[] = [];

  get id(): number {
    return Number(this.$route.params.id ?? 0);
  }

  get companyId(): number {
    return Number(this.$route.params.company_id ?? 0);
  }

  get endpoint() {
    const { companyId, id } = this;

    if (!id) return "";

    if (companyId) return API_ROUTES.EXPERT_COMPANIES_EMPLOYEES_HISTORY(companyId, id);

    return API_ROUTES.COMPLIANCE_PROFILE_HISTORY_EMPLOYEE(id);
  }

  async fetchHistory(): Promise<void> {
    if (!this.endpoint) return;

    try {
      this.loading = true;

      const { data } = await this.axios.get<API_THistory[]>(this.endpoint);

      if (!data) return;

      this.historyItems = convertHistoryForTable(data);
    } finally {
      this.loading = false;
    }
  }

  mounted() {
    this.$root.$on("update-employee-level-data", this.fetchHistory);
  }

  beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: RawLocation | ((vm: Vue) => void)) => void
  ): void {
    next((vm: any) => {
      vm.fetchHistory();
    });
  }
}
